module.exports = __webpack_public_path__ + "img/nopro.2473a20a.png";